import { ImageQuality } from '@pcp/core/interfaces';

/**
 * Matches the terminal image-quality filename segment of a slide resource URL,
 * e.g. the `/low.webp` in `…/slides/202/260/102037/low.webp?{sas}`.
 *
 * Anchored to the filename position: the segment must be preceded by `/` and
 * followed by the end of the path (end of string or the `?` starting the query),
 * so quality-like text elsewhere in the URL (e.g. `…/yellow.webp`, a `low.webp/`
 * path directory) is never swapped.
 */
const QUALITY_FILENAME_SEGMENT = /\/(?:low|med|high)\.webp(?=$|\?)/;

/**
 * Swaps the quality filename segment of a slide image URL to the given quality,
 * by URL convention (`…/{low|med|high}.webp?{sas}`). The query string (SAS token,
 * container-scoped) is preserved. URLs without a quality segment — bookpages,
 * empty strings, non-slide resources — are returned unchanged.
 *
 * This is the single source of truth for the quality-swap convention: exactly one
 * URL is synced per image (Y.Doc / SignalR carry no variant maps) and each client
 * derives its preferred variant locally via this function.
 */
export const swapImageQualityInUrl = (url: string, quality: ImageQuality): string =>
    url.replace(QUALITY_FILENAME_SEGMENT, `/${quality}.webp`);
